import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SetAnswersValue } from "../../../../../redux/slice/SurveySlice/AnswerSlice";

import { RadioGroup, FormControlLabel, Radio, Box } from "@mui/material";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";

export default function SingleChocie({
  options,
  questionsindex,
  answers,
  onChangeSingle,
  AnswersFontScales
}) {
  const dispatch = useDispatch();


  useEffect(() => {
    console.log("answersSingle:",answers);
  },[answers]);

  function onChangeAnswer(value) {
    onChangeSingle();
    dispatch(SetAnswersValue({ index: questionsindex, value }));
  }
  return (
    <>
      {!!options ? (
        <>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            onChange={(e) => onChangeAnswer(e.target.value)}
          >
            {options.map((answer, index) => (
              <div key={index}>
                {parseInt(answers) === index ? (
                  <FormControlLabel
                    disabled={answers !== undefined ? true : false}
                    key={index}
                    className="flex items-center w-full md:py-4 py-2 pl-5 m-2 space-x-2 border-2 cursor-pointer bg-blue-300 border-black/10 rounded-xl"
                    value={answers !== undefined ? answers : index}
                    control={<Radio
                      sx={{ '& .MuiSvgIcon-root': { fontSize: AnswersFontScales } }}
                    />}
                    label={
                      <Box
                        component="div"
                        fontSize={AnswersFontScales}
                        sx={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          width: '100%',
                          display: 'block',
                        }}
                        className="text-left break-words w-full pr-2"
                      >

                        {answer}
                      </Box>
                    }
                  />
                ) : (
                  <FormControlLabel
                    disabled={answers !== undefined ? true : false}
                    key={index}
                    className="flex items-center w-full md:py-4 py-2 pl-5 m-2 space-x-2 border-2 cursor-pointer bg-black/5 border-black/10 rounded-xl"
                    value={answers !== undefined ? answers : index}
                    control={<Radio
                      sx={{ '& .MuiSvgIcon-root': { fontSize: AnswersFontScales } }}
                    />}
                    label={
                      <Box
                        component="div"
                        fontSize={AnswersFontScales}
                        sx={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          width: '100%',
                          display: 'block',
                        }}
                        className="text-left break-words w-full pr-2"
                      >
                        {answer}
                      </Box>
                    }
                  />
                )}
              </div>
            ))}
          </RadioGroup>
        </>
      ) : (
        ""
      )}
    </>
  );
}
